module.exports = __webpack_public_path__ + "static/sprite-logo@2x-77467749e8ff264ce5d8a8d6c6886a84.jpg";